import {CtxType} from "../init_ab_testing_instance";
import {IABTestConfiguration, IVariantConfigParams} from "../types/IABTestConfiguration";
import {IAmplitudeVariantsMap, specifyABTestVariant, specifyAmplitudeABTestVariant} from "../utils/ab_testing_ssr";

export const getABTestDataAction = (
    abTest: IABTestConfiguration,
    ctx: CtxType,
    domain: string,
    params?: IVariantConfigParams,
    amplitudeVariants?: IAmplitudeVariantsMap
): string => {
    const variant =
        abTest.useAmplitude && amplitudeVariants
            ? specifyAmplitudeABTestVariant(abTest, amplitudeVariants, domain, ctx.req, ctx.meta)
            : specifyABTestVariant(abTest, domain, ctx.req, ctx.meta, params);

    return `${abTest.id}.${variant}`;
};
import {CtxType} from "../init_ab_testing_instance";
import {IABTestConfiguration, IVariantConfigParams} from "../types/IABTestConfiguration";
import {IAmplitudeVariantsMap, specifyABTestVariant, specifyAmplitudeABTestVariant} from "../utils/ab_testing_ssr";

export const getABTestDataAction = (
    abTest: IABTestConfiguration,
    ctx: CtxType,
    domain: string,
    params?: IVariantConfigParams,
    amplitudeVariants?: IAmplitudeVariantsMap
): string => {
    const variant =
        abTest.useAmplitude && amplitudeVariants
            ? specifyAmplitudeABTestVariant(abTest, amplitudeVariants, domain, ctx.req, ctx.meta)
            : specifyABTestVariant(abTest, domain, ctx.req, ctx.meta, params);

    return `${abTest.id}.${variant}`;
};
